// Changes WhatsApp message formatting to HTML tags
const formatWAMessage = (text) => {
  if (text) {
    return text
      .replace(/(?:\*)(?:(?!\s))((?:(?!\*|\n).)+)(?:\*)/g, "<b>$1</b>")

      .replace(
        /_(?!\s)(?![^_]*\{\{)(?![^_]*\}\})(?![^}]*\}\})(?![^}]*\{\{)((?:(?!_).)+)_/g,
        "<i>$1</i>"
      )

      .replace(/(?:~)(?:(?!\s))((?:(?!\n|~).)+)(?:~)/g, "<s>$1</s>")
      .replace(/(?:--)(?:(?!\s))((?:(?!\n|--).)+)(?:--)/g, "<u>$1</u>")
      .replace(/(?:`)(?:(?!\s))((?:(?!\n|`).)+)(?:`)/g, "<code>$1</code>");
  } else {
    return text;
  }
};

export default formatWAMessage;
